import React from "react";

interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, action }) => (
  <div className="flex flex-col items-center gap-2 rounded-card border border-dashed border-line-strong px-4 py-12 text-center">
    <p className="text-body font-medium text-fg">{title}</p>
    {description && <p className="max-w-sm text-caption text-fg-muted">{description}</p>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);
